import React, { Component } from 'react';
import swal from 'sweetalert';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Input } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { MultiSelect } from '@progress/kendo-react-dropdowns';
import { connect } from 'react-redux';
import { selectMembershipType, selectMembershipPackage, fetchMembershipTypes, fetchMembershipPackages } from '../../../../../../../Redux/Actions/EndUser/MembershipAction';
import { fetchAllMemberships, updateAdminMembership, addAdminMembership } from '../../../../../../../Redux/Actions/Admin/ManageMembershipActions';
import { fetchStates } from '../../../../../../../Redux/Actions/CommonActions';
import '../../../ManageMembership/ManageMembership.scss';

import {
    addToPurchase,
    updatePurchase,
    changeView,
    setAlert
} from '../../../../../../../Redux/Actions/Admin/ManagePurchaseAndRenewalsActions';

import IsLoading from '../../../../../../Shared/Loading/IsLoading';
import { Alert } from 'reactstrap';

import axios from 'axios';
import { ROOT_API_URL } from '../../../../../../../api-config';
import _ from 'lodash';
import { auth } from '../../../../../../../services';


const initialState = {
    firstRender: false,
    membershipInEdit: {},
    value: [],
    membershipLookup: false,
    membershipLookupEmail: "",
    membershipData: [],
    selectedMember: null,
    view: "AdditionalDues",
    firstName: "",
    lastName: "",
    total: 0,
    id: 0,
    UserId: "",
    Name: "",
    ActualCost: 0,
    SuggestedCost: 0,
    email: "",
    dueAmount: 0
}

class AdditionalDues extends Component {
    constructor(props) {
        super(props);
        this.state = initialState;

        this.delayedCallback = _.debounce(this.checkEmailCall, 2000);
        this.onEmailChange = this.onEmailChange.bind(this);
    }
    componentDidMount() {
        this.props.fetchAllMemberships();
        this.props.fetchStates();
        if (this.props.purchaseAndRenewals.editingPurchase) {
            this.setState({
                ...this.props.purchaseAndRenewals.editingPurchase
            })
        }

        if (this.props.purchaseAndRenewals.userInfo) {
            this.setState(
                {
                    firstRender: true,
                    membershipLookupEmail: (10000000 + this.props.purchaseAndRenewals.userInfo.membershipId).toString()
                }, () => {
                    this.checkEmailCall();
                }
            );
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.purchaseAndRenewals.editingPurchase !== this.props.purchaseAndRenewals.editingPurchase) {
            this.setState({
                ...this.props.purchaseAndRenewals.editingPurchase
            })
        }
    }

    checkEmailCall() {
        this.setState({ isLoading: true })
        const options = { params: { searchTerm: this.state.membershipLookupEmail }, method: 'GET', headers: auth.authHeader() };
        axios.get(`${ROOT_API_URL}/ManageTransaction/SearchMembership`, options)
            .then((response) => {
                if (response.data.length > 0) {
                    this.setState({
                        membershipData: response.data,
                        isLoading: false
                    },
                        () => this.props.setAlert(true, "Users Found", 'success')
                    );

                    if (this.state.firstRender) {
                        let shouldBreak = false;

                        response.data.map(membership => {
                            if (!shouldBreak && (membership.membershipId == this.props.purchaseAndRenewals.userInfo.membershipId)) {
                                shouldBreak = true;
                                this.props.fetchMembershipPackages(membership.membershipType.membershipTypeID);
                                this.setState({
                                    IsRenewal: true,
                                    selectedMember: membership,
                                    membershipId: membership.membershipId,
                                    email: membership.email
                                });
                            }
                        });

                        this.setState({
                            firstRender: false
                        });
                    }

                    setTimeout(() => {
                        this.props.setAlert(false, "");
                    }, 5000)
                } else if (response.data.length === 0) {
                    this.setState({
                        ...initialState,
                        membershipLookupEmail: this.state.membershipLookupEmail,
                        isLoading: false,
                    },
                        () => this.props.setAlert(true, "No Users Found", 'danger')
                    );
                    setTimeout(() => {
                        this.props.setAlert(false, "");
                    }, 5000)
                } else {
                    this.setState({
                        ...initialState,
                        isLoading: false,
                        membershipLookupEmail: this.state.membershipLookupEmail
                    },
                        () => this.props.setAlert(true, response.data.message, 'danger')
                    );
                    setTimeout(() => {
                        this.props.setAlert(false, "");
                    }, 5000)
                }
            })
            .catch((response) => {
                this.setState({
                    isLoading: false
                },
                    () => this.props.setAlert(true, response.message, 'danger')
                )
            });
    }

    onEmailChange = (event) => {
        var userId = '';
        if (auth.isAuthenticated()) {
            userId = auth.getAuthUserId()
        }
        this.setState(
            {
                membershipLookupEmail: event.target.value,
                userID: userId

            },
            () => {
                this.delayedCallback();
            }

        );
    };

    handleBlur = (field) => (evt) => {
        this.setState({
            touched: { ...this.state.touched, [field]: true },
        });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        const newState = Object.assign({}, this.state);
        console.log(newState.selectedMember.memberNumber,"submit newstate")
        newState.ActualCost = Number(newState.dueAmount);
        newState.SuggestedCost = Number(newState.dueAmount);
        newState.Name = "MemberNumber " + newState.selectedMember.memberNumber;
        this.setState(newState);
        if (this.props.purchaseAndRenewals.editingPurchase.Name) {
            this.props.updatePurchase(newState);
        } else {
            this.props.addToPurchase(newState);
        }
        this.props.changeView({ view: "AddItems" })
    };

    isCustom(item) {
        return item.id === undefined;
    };

    addKey(item) {
        item.id = new Date().getTime();
    };

    onDialogInputChange = (event) => {
        let target = event.currentTarget;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.props ? target.props.name : target.name;

        const edited = this.state;
        if (name == "dueAmount") {

            value = target.valueAsNumber;

            if (value < 0) {
                value = 0;
                target.valueAsNumber = 0;
            }
        }
        edited[name] = value;
        edited.isActive = true;
        this.setState({
            ...edited
        });
    };

    handleMultiSelectChange = (event) => {
        var currentState = { ...this.state };
        currentState.permissions = [...event.target.value];
        this.setState({
            ...currentState
        });
    };

    handleChange = (event) => {
        this.selectedMembershipType(event.target.value);
    };

    selectedMembershipType = (value) => {
        this.props.selectMembershipType(value);
        if (value !== null) {
            const newState = Object.assign({}, this.state);
            newState.membershipType = value;
            this.setState(newState);
            this.props.fetchMembershipPackages(value.membershipTypeID);
        }
    };

    handlePackageChange = (event) => {
        const newState = Object.assign({}, this.state);
        newState.membershipPackage = event.target.value;
        this.setState(newState);
        this.props.selectMembershipPackage(event.target.value);
    };

    handleState = (event) => {
        const value = event.target.value;
        if (value !== null) {
            this.setState({ state: value });
        }
    };

    handleMembershipSelectChange = (event) => {
        if (event.target.value !== null) {
            this.props.fetchMembershipPackages(event.target.value.membershipType.membershipTypeID);
            this.setState({
                IsRenewal: true,
                selectedMember: event.target.value,
                membershipId: event.target.value.membershipId,
                email: event.target.value.email
            });
        }
    }

    render() {
        return (
            <div>
                <Alert
                    color={this.props.purchaseAndRenewals.color}
                    isOpen={this.props.purchaseAndRenewals.visible}
                    style={{ position: 'fixed', width: '100%', height: '50px', zIndex: '1', top: '2px', left: '0' }}
                >
                    {this.props.purchaseAndRenewals.message}
                </Alert>
                <div className="row">
                    <div className="col-md-12">
                        <label htmlFor="exampleEmail" className="label-header">Membership Lookup: </label>
                        <Input name="membershipLookupEmail"
                            id="membershipLookupEmail"
                            value={this.state.membershipLookupEmail}
                            onChange={this.onEmailChange}
                            type="text"
                            placeholder="Please enter member ID, email, or name."
                        />
                    </div>
                </div>
                {this.state.membershipData.length > 0 ?
                    <div className="row">
                        <div className="form-group col-md-12">
                            <label htmlFor="subscriptionId">Please Select Member</label>
                            <DropDownList data={this.state.membershipData}
                                textField="fullName"
                                dataItemKey="membershipId"
                                onChange={this.handleMembershipSelectChange}
                                value={this.state.selectedMember}
                                allowCustom={false}
                                filterable={false}
                                clearButton={false}
                                width={300}
                                required={true}
                            />
                        </div>
                    </div> : ""
                }

                {
                    this.state.isLoading ? (
                        <IsLoading message="Loading User Information" />
                    ) : (
                            <form className="user-form membership-form" onSubmit={this.handleSubmit}>
                                {(this.props.purchaseAndRenewals.editingPurchase.view === "AdditionalDues") && this.state.selectedMember ?
                                    <div>
                                        <div className="form-group">
                                            <h2 className="callout">Enter <span className="highlight">Additional Dues</span></h2>
                                        </div>
                                        <div className="row">
                                            <div className="form-group col-md-6">
                                                <label htmlFor="dueAmount">Amount</label>
                                                <input
                                                    id="dueAmount"
                                                    type="number"
                                                    value={this.state.dueAmount}
                                                    onChange={this.onDialogInputChange}
                                                    min="0"
                                                    name="dueAmount"
                                                />
                                            </div>

                                        </div>

                                    </div>
                                    : ""}
                                <div className="footer">
                                    <div className="form-group">
                                        {(this.props.purchaseAndRenewals.editingPurchase.view === "AdditionalDues") && this.state.selectedMember ?
                                            <button type="submit" className="admin-k-button">
                                                <i className="fas fa-save"></i>
                                                <span>SAVE</span>
                                            </button>
                                            : ""}
                                        <button className="admin-k-button" onClick={() => this.props.changeView({ view: "AddItems" })}>
                                            <i className="fas fa-times"></i>
                                            <span>CANCEL</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        )
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        membership: state.membership,
        common: state.common,
        purchaseAndRenewals: state.purchaseAndRenewals
    };
}

export default connect(mapStateToProps, {
    fetchStates,
    fetchAllMemberships,
    fetchMembershipTypes,
    fetchMembershipPackages,
    selectMembershipType,
    selectMembershipPackage,
    addAdminMembership,
    updateAdminMembership,
    addToPurchase,
    updatePurchase,
    changeView,
    setAlert
})(AdditionalDues);